import { SignIn } from '@clerk/react'
import { useRef } from 'react'

const APP_URL = import.meta.env.VITE_APP_URL

function App() {
  const fallbackUrl = useRef(
    new URLSearchParams(window.location.search).get('redirect_url') || APP_URL
  ).current

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', gap: '1.5rem' }}>
      <img src="/logo.svg" alt="Reset Energia" style={{ height: '2.5rem' }} />
      <SignIn fallbackRedirectUrl={fallbackUrl} />
    </div>
  )
}

export default App